import { useEffect, useState } from "react";

const SECTIONS = [
    { id: "shop", label: "01 · Shop" },
    { id: "countdown", label: "02 · Drop Timer" },
    { id: "worn", label: "03 · Worn" },
    { id: "studio", label: "04 · Studio" },
    { id: "story", label: "05 · Story" },
];

export default function SectionRail() {
    const [active, setActive] = useState("");
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const onScroll = () => {
            const h = document.documentElement.scrollHeight - window.innerHeight;
            setProgress(h > 0 ? window.scrollY / h : 0);

            let current = "";
            for (const s of SECTIONS) {
                const el = document.getElementById(s.id);
                if (!el) continue;
                const rect = el.getBoundingClientRect();
                if (rect.top < window.innerHeight * 0.5) {
                    current = s.id;
                }
            }
            setActive(current);
        };
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <>
            {/* Top progress bar */}
            <div
                aria-hidden
                className="fixed top-0 left-0 right-0 h-px bg-transparent z-[55]"
                data-testid="scroll-progress"
            >
                <div
                    className="h-full bg-white origin-left"
                    style={{ transform: `scaleX(${progress})` }}
                />
            </div>

            {/* Side rail */}
            <aside
                aria-hidden
                className="hidden lg:flex fixed top-1/2 -translate-y-1/2 right-6 z-40 flex-col gap-3 items-end"
                data-testid="section-rail"
            >
                {SECTIONS.map((s) => (
                    <a
                        key={s.id}
                        href={`#${s.id}`}
                        className={`group flex items-center gap-2 font-mono text-[9px] uppercase tracking-[0.25em] transition-colors ${
                            active === s.id ? "text-white" : "text-white/30 hover:text-white"
                        }`}
                    >
                        <span className="opacity-0 group-hover:opacity-100 transition-opacity">
                            {s.label}
                        </span>
                        <span
                            className={`block transition-all ${
                                active === s.id
                                    ? "w-8 h-px bg-white"
                                    : "w-4 h-px bg-white/40"
                            }`}
                        />
                    </a>
                ))}
            </aside>
        </>
    );
}
